module.exports = __webpack_public_path__ + "static/media/SP_S_Jacquard_City Life_Bordeaux_PW Pink.7def9a82.png";